import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { GlobalStyles } from './styles/GlobalStyles';
import { Theme } from './styles/Theme';
import { ThemeProvider } from 'styled-components';
import ChatPage from './pages/ChatPage';
import { AuthProvider } from './contexts/AuthContext';
import { ProjectProvider } from './contexts/ProjectContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ReportProvider } from './contexts/ReportContext';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const App: React.FC = () => {
  return (
    <ThemeProvider theme={Theme}>
      <GlobalStyles />
      <NotificationProvider>
        <AuthProvider>
          <ProjectProvider>
            <ReportProvider>
              <Router>
              <AppContainer>
                <Routes>
                  <Route path="/" element={<ChatPage />} />
                  <Route path="/chat" element={<ChatPage />} />
                </Routes>
              </AppContainer>
              </Router>
            </ReportProvider>
          </ProjectProvider>
        </AuthProvider>
      </NotificationProvider>
    </ThemeProvider>
  );
};

export default App;